module.exports = __webpack_public_path__ + "media/images/admin/favicons/favicon-93e66392bb383798801a6f15f318a15c.ico";